import React, { useState, useEffect } from 'react';
import { object, oneOfType, number, string, func } from 'prop-types';
import InfoIcon from '@material-ui/icons/Info';
import HelpIcon from '@material-ui/icons/Help';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '../Typography';
import piwik from '../../services/analytics';

const ICON_TYPE = {
  HELP_ICON: 'help',
  INFO_ICON: 'info',
};

const MyTooltip = ({ content, type = ICON_TYPE.INFO_ICON, placement, trackingEvent }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    if (!isOpen && trackingEvent) {
      piwik.trackEvent(trackingEvent);
    }
    setIsOpen(prev => !prev);
  };

  const handleClickOutside = event => {
    if (!event.target.closest('[name="tooltip"]')) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  const IconComponent = type === ICON_TYPE.HELP_ICON ? HelpIcon : InfoIcon;

  return (
    <Tooltip
      name="tooltip"
      title={<Typography content={content} variant="subtitle2" />}
      open={isOpen}
      placement={placement}
      disableFocusListener
      disableHoverListener
    >
      <IconComponent color="secondary" onClick={handleToggle} />
    </Tooltip>
  );
};

MyTooltip.propTypes = {
  content: oneOfType([number, object, string]),
  type: string,
  placement: string,
  trackingEvent: func,
};

export default MyTooltip;
